import { Component, OnInit } from '@angular/core';
import { SummarizeOrderJeevesComponent } from 'gung-standard-jeeves';

@Component({
  selector: 'tylo-summarize-order-jeeves',
  templateUrl: './tylo-summarize-order-jeeves.component.html',
  styleUrls: ['./tylo-summarize-order-jeeves.component.css']
})
export class TyloSummarizeOrderJeevesComponent extends SummarizeOrderJeevesComponent implements OnInit {
  isUser: boolean;

  ngOnInit() {
    super.ngOnInit();
    this.authService.getRoles().subscribe(roles => {
      this.isUser = roles.length === 1 && roles.includes('USER');
    });
  }
}
